<template>
    <div ref="contentBlock" class="scoped-html-host"  :class="{ 'collapsed': !isExpanded }">
      <p v-if="contentExceedsLimit" class="expand-toggle mt-3" @click="isExpanded = !isExpanded">
          {{ isExpanded ? 'Afficher moins' : 'Afficher plus' }}
      </p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ScopedHtmlRenderer',
    data() {
			return {
				isExpanded: false,
                contentExceedsLimit: false,
    };
    },
    props: ['html'],
    inheritAttrs: false,
    mounted() {
      const shadowRoot = this.$refs.contentBlock
      shadowRoot.innerHTML = this.html;
      const el = this.$refs.contentBlock;
    if (el && el.scrollHeight > 300) {
    this.contentExceedsLimit = true;
    }
    },
    watch: {
      html(newHtml) {
        const shadowRoot = this.$refs.contentBlock.shadowRoot;
        if (shadowRoot) {
          shadowRoot.innerHTML = newHtml;
        }
      }
    }
  };
  </script>  